import { css } from 'emotion'

export const TitleWatcherStyles = css``
